export default "__VITE_ASSET__BU$FkYBU__"